export const statuses = [
    {
        name: "New",
        value: 1
    },
    {
        name: "Verified",
        value: 2
    },
    {
        name: "Connected",
        value: 3
    },
    {
        name: "In Progress",
        value: 4
    },
    {
        name: "Follow Up",
        value: 5
    },
    {
        name: "Qualified",
        value: 6
    },
    {
        name: "Un Qualified",
        value: 7
    },
    {
        name: "Site Visit",
        value: 8
    },
    {
        name: "Oppurtunity",
        value: 9
    },
    {
        name: "Lost",
        value: 10
    },
    {
        name: "Dead",
        value: 11
    }
]


export const oppStatus = [
    {
        name:"New Oppurtunity",
        value: 1
    },
     {
        name:"Negotiation",
        value: 2
    },
     {
        name:"In Progress",
        value: 3
    },
     {
        name:"Agreement Done",
        value: 4
    },
     {
        name:"Won/Closed",
        value: 5
    },
     {
        name:"Dead",
        value: 6
    },
     {
        name:"Lost",
        value: 7
    }
]